import { createContext, useContext, useState } from "react";

// Screens: "home" | "loanDetails" | "rejected" | "profile"
const NavContext = createContext(null);

export function NavProvider({ children }) {
  const [screen, setScreen] = useState("home");
  const navigate = (s) => setScreen(s);
  return (
    <NavContext.Provider value={{ screen, navigate }}>
      {children}
    </NavContext.Provider>
  );
}

export const useNav = () => useContext(NavContext);
